import type { AdminMoneyHealthListDto, AdminMoneyHoldDto } from '@carcheck/shared';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { HoldRow } from './HoldRow';
import { EscalatedIcon } from './icons';
import { SectionCard } from './SectionCard';
import { SectionMeta } from './SectionMeta';
import { countText, truncationText } from '../_lib/moneyHealthText';

/**
 * «Холды без автоматики» — `capture.phase === 'needs_operator'`.
 *
 * The only list on this screen that is always an alert: nothing automatic will
 * move this money, and `capture.blockedReason` says why. Every other section
 * has a healthy reading; this one does not.
 */
export const EscalatedHoldsSection = ({
  list,
  now,
}: {
  list: AdminMoneyHealthListDto<AdminMoneyHoldDto>;
  now?: number | undefined;
}): ReactElement => {
  const { t } = useTranslation();
  const count = countText(list);
  const total = t(count.key, { ...count.values });
  const truncation = truncationText(list, total);

  return (
    <SectionCard
      data-testid="section-escalated"
      tone="alert"
      icon={<EscalatedIcon />}
      title={t('moneyHealth.escalated.title')}
      subtitle={t('moneyHealth.escalated.sub')}
      tag={{ label: t('moneyHealth.escalated.tag'), tone: 'alert' }}
      count={total}
      footer={truncation === null ? undefined : <SectionMeta text={truncation} />}
    >
      {list.items.map((hold) => (
        <HoldRow key={hold.paymentId} hold={hold} showPaymentId now={now} />
      ))}
    </SectionCard>
  );
};
